exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#filtering-vertical-form{width:90%;margin-left:5%}#filtering-vertical-form .data-filter-row-title{padding:10px;font-size:16px}#filtering-vertical-form .data-filter-row-content{padding:20px;background-color:#fff;margin-bottom:20px}#filtering-vertical-form .data-filter-row-content .data-filter-row-item{font-size:13px;text-align:center;margin-left:10px}#filtering-vertical-form .data-filter-row-content .data-filter-row-item .data-filter-row-item-label{margin-left:0}#filtering-vertical-form .data-filter-row-content span.data-filter-row-item-title{font-size:13px;display:flex}#filtering-vertical-form .data-filter-row-content .data-filter-submit-btn-container{width:100%;text-align:center}.variables-select .ant-select-selection{min-height:100%;max-height:100%;overflow:overlay}.min-max-variable-table .ant-form-item{margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/lib/loader.js!./styles/dataFilterAnalytics.scss
// module id = 2186
// module chunks = 43